import { render, staticRenderFns } from "./GalleryBig7.vue?vue&type=template&id=6ce723ec&scoped=true&"
import script from "./GalleryBig7.vue?vue&type=script&lang=js&"
export * from "./GalleryBig7.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig7.vue?vue&type=style&index=0&id=6ce723ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce723ec",
  null
  
)

export default component.exports